import classNames from 'classnames';
import React, { useState } from 'react';
import { Section } from '../../platformui';
import SemanticHeader from '../../platformui/Chapter/semantic-header';
import { TeaserItemLink } from '../../platformui/Teaser';
import { CheckboxWithImg } from '../c-checkbox-with-img';

const CheckListContainer = ({
  CurrentPageProps,
  Heading,
  blockId,
  MainContent,
  Description,
  CheckListContainerMode,
  Items,
  HeadingList,
  Ingress,
  HeadingListAllChecked,
  IngressAllChecked,
  SubmitText,
}) => {
  const [checkedItems, setCheckedItems] = useState(
    Items?.reduce((acc, item) => {
      acc[item.BlockId] = item.IsChecked;
      return acc;
    }, {})
  );
  const [results, setResults] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showAllResults, setShowAllResults] = useState(false);

  const allItemsChecked =
    Object.values(checkedItems)?.filter(Boolean).length === MainContent?.length;

  const handleOnChange = (blockId) => {
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [blockId]: !prevCheckedItems[blockId],
    }));
  };

  const handleSubmit = () => {
    const filteredResults = Items?.filter((item) =>
      CheckListContainerMode
        ? !checkedItems[item.BlockId]
        : checkedItems[item.BlockId]
    ).sort((a, b) => a.PriorityOrder - b.PriorityOrder);
    setResults(filteredResults);
    setIsSubmitted(true);
  };

  const displayedResults = showAllResults ? results : results.slice(0, 4);

  const resultClasses = classNames({
    'c-checklist-container__results__article-wrapper': true,
    'c-checklist-container__results__article-page':
      CurrentPageProps.PageTypeName === 'ArticlePage',
  });

  if (!Items) return null;

  return (
    <Section customClass="c-section--checklist-container">
      <div className="c-checklist-container">
        <div className="c-checklist-container__text-wrapper">
          <SemanticHeader
            className="c-checklist-container__heading"
            id={`checklist-container-${blockId}`}
            tabIndex={-1}
          >
            {Heading}
          </SemanticHeader>
          <p className="c-checklist-container__description">{Description}</p>
        </div>
        <div className="c-checklist-container__checkbox-wrapper">
          {MainContent?.length > 0 &&
            MainContent.map((block, index) => (
              <CheckboxWithImg
                key={index}
                text={block.Question}
                imageUrl={block.ImageSrc}
                imageDesc={block.ImageDescription}
                checked={checkedItems[block.BlockId]}
                onChange={() => handleOnChange(block.BlockId)}
                isSubmitted={isSubmitted}
              />
            ))}
        </div>
        {isSubmitted ? (
          <div className="c-checklist-container__results">
            <div className="c-checklist-container__text-wrapper">
              <SemanticHeader
                isH3
                className="c-checklist-container__results__heading"
              >
                {allItemsChecked && HeadingListAllChecked
                  ? HeadingListAllChecked
                  : HeadingList}
              </SemanticHeader>
              <p className="checklist-container__results__text">
                {allItemsChecked && IngressAllChecked
                  ? IngressAllChecked
                  : Ingress}
              </p>
            </div>
            <div className={resultClasses}>
              {displayedResults.map((result, index) => (
                <TeaserItemLink
                  key={`teaser-result${index}`}
                  horizontalDirection
                  Media={result.Media}
                  Title={result.Heading}
                  Preamble={result.Description}
                  Url={result.Url}
                />
              ))}
            </div>
            {!showAllResults && results.length > 4 && (
              <button
                aria-label="Visa fler artiklar"
                type="button"
                tabIndex={0}
                className="c-checklist-container__show-more"
                onClick={() => setShowAllResults(true)}
              >
                Visa fler artiklar
              </button>
            )}
          </div>
        ) : (
          <button
            aria-label={SubmitText || 'Skicka dina svar'}
            type="button"
            tabIndex={0}
            className="c-checklist-container__submit"
            onClick={handleSubmit}
            disabled={
              !Object.values(checkedItems).some((isChecked) => isChecked) &&
              !CheckListContainerMode
            }
            aria-disabled={
              !Object.values(checkedItems).some((isChecked) => isChecked) &&
              !CheckListContainerMode
            }
          >
            {SubmitText || 'Skicka dina svar'}
          </button>
        )}
      </div>
    </Section>
  );
};

export default CheckListContainer;
